export const setAuthorisationToken = (bearerToken: string) => {
  window.localStorage.setItem('BearerToken', bearerToken);
};
